// Types
export const ALL = 'all'
export const TYPE_TEXT = 1
export const TYPE_VOICE = 2

// Directions
export const DIRECTION_INBOUND = 1
export const DIRECTION_OUTBOUND = 2

// Enrollment Types
export const ENROLLMENT_TYPE_TEXT = 1
export const ENROLLMENT_TYPE_VOICE = 2

// Why an agent was stopped for a contact (disengaged-bots `reason`; null on stops recorded before reasons existed)
export const STOP_REASON_REP = 'rep'
export const STOP_REASON_AGENT = 'agent'
export const STOP_REASON_DNC = 'dnc'
